import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProductsService } from '../../../infrastructure/services/products.service';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { Product } from 'app/infrastructure/model/interfaces/product.interface';

@Component({
  templateUrl: '../../product/detalle/detail.product.component.html',
  styleUrls: ['../../configuracion/subscription/nuevo.subscription.component.css'],
})

export class DetailProductComponent implements OnInit {
  product: Product;
  codOrganization: string;
  codSubscription: string;
  codChannel: string;
  codProduct: string;
  seccionActual: string;
  esNuevo = true;
  checkeandCodigo = false;
  errorCodigo = null;
  completitud = 0;
  editable = false;

  constructor(public loaderService: LoaderService,
    private alertService: AlertService,
    private productService: ProductsService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private translator: Translator) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codOrganization = params['codorganizacion'];
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
      this.codProduct = params['codproducto'];

      this.esNuevo = false;

      if (this.codProduct === 'nuevo') {
        this.esNuevo = true;
        this.product = {
          codProduct: '',
          codSubscription: this.codSubscription,
          codChannel: this.codChannel,
          descripcion: <string>this.translator.instant('PRODUCTO_DESCRIPCION'),
          importedConfiguration: false,
          codOrganization: this.codOrganization
        };
        return;
      }
      this.productService
        .getDetailProduct(this.codOrganization, this.codSubscription, this.codChannel, this.codProduct)
        .subscribe(data => {
          if (!data) {
            return this.router.navigateByUrl('/soc/404');
          }
          this.product = data;
          this.editable = !this.product.importedConfiguration;
          this.inicializarCampos(data);
        });
    });
  }

  validarCodigo() {
    this.errorCodigo = null;

    if (!this.product.codProduct || this.product.codProduct.length <= 0) {
      this.errorCodigo = <string>this.translator.instant('AL_MENOS_1_CARACTER');
      return false;
    }

    if (this.product.codProduct.length > 10) {
      this.errorCodigo = <string>this.translator.instant('MAX_LONGITUD', { max: 10 });
      return false;
    }

    if (this.product.codProduct === 'nuevo') {
      this.errorCodigo = <string>this.translator.instant('CODIGO_INVALIDO');
      return false;
    }

    return true;
  }

  createProduct() {
    if (!this.validarCodigo()) {
      return;
    }

    this.checkeandCodigo = true;

    // Check para ver que el codigo de producto no esta usado
    this.productService.getDetailProductStatus(this.codOrganization, this.codSubscription, this.codChannel, this.product.codProduct, 'B')
      .subscribe(res => {
        this.checkeandCodigo = false;
        // Si el codigo ya existe, no puedo crear un producto
        if (res !== null) {
          this.errorCodigo = <string>this.translator.instant('CODPRODUCT_EXISTS');
          return false;
        }

        // Creo el sistema
        this.productService
          .crear(this.product)
          .then(product => {
            this.alertService.showGrowl({
              type: GrowlType.SUCCESS,
              body: 'PRODUCTO_CREADO_CORRECTAMENTE',
            });

            this.router.navigate(['../', product.codProduct], { relativeTo: this.aRoute.parent });
          });
      });
  }

  editarDescripcion(nuevoTexto) {
    this.product.descripcion = nuevoTexto;
    this.productEdit({ descripcion: nuevoTexto });
  }

  editarDescripcionExt(nuevoTexto) {
    this.product.descripcionExt = nuevoTexto;
    this.productEdit({ descripcionExt: nuevoTexto });
  }

  /**
   * Actualiza la Imagen del sistema en el backend
   */
  editarImagen(nuevaImagen) {
    this.product.imagen = nuevaImagen.imagenBase64;
    this.productEdit({ imagen: nuevaImagen.imagenBase64 });
  }

  private productEdit(cambios) {
    this.productService.editar(this.product.codOrganization, this.product.codSubscription, this.product.codChannel, this.product.codProduct, cambios)
      .then(data => {
        this.inicializarCampos(data);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EDITADO_CORRECTAMENTE',
        });
      });
  }

  private inicializarCampos(data) {
    if (data) {
      this.completitud = data.completitud ? JSON.parse(data.completitud).porcentaje : 0;
      this.product.fechaActualizacion = data.fechaActualizacion;
      this.product.modificado = data.modificado;
      this.product.urlImage = data.urlImage;
    }
  };
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/detalle/detail.product.component.ts